import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { favoriteAlbums, deleteAlbumItems, downloadAlbumItems,requestAddAlbumItemsToAlbum } from '../../album-view/actions/album-item-actions';


import { applicationHistory } from '../../common/application-history';
import {
	enableAlbumItemSelectionMode,
	disableAlbumItemSelectionMode
} from '../../settings/actions/application-actions';
import { clearSelectedAlbumItems, clearAlbumItems } from '../../album-view/actions/album-item-actions';
import MediaDownloadDialog from "../../album-view/components/dialog/media-download-dialog";
import AddToDiscDialog from "../../disc/components/dialog/add-to-disc-dialog";
import ConfirmationDialog from "../../common/components/confirmation-dialog";
import ShareDialog from '../../common/components/share-dialog';
import AddToAlbumDialog from "../../album-view/components/dialog/add-to-album-dialog";
import {albumListRequested} from "../../album-view/actions/album-actions";

class AlbumItemSelectModeHeader extends Component {
	constructor(props) {
		super(props);
    this.state = {
		isAddToDiscDialogOpen: false,
		isDownloadDialogOpen: false,
		isDeleteDialogOpen: false,
		isShareDialogOpen: false,
		isAddToAlbumDialogOpen: false
    };
		this.favoriteAlbumItems = this.favoriteAlbumItems.bind(this);
		this.deleteSelectedItems = this.deleteSelectedItems.bind(this);
		this.deleteAlbumItemsDialog = this.deleteAlbumItemsDialog.bind(this);
		this.cancelSelection = this.cancelSelection.bind(this);
		this.downloadAlbumItems = this.downloadAlbumItems.bind(this);
		this.addSelectedItemsToDisc = this.addSelectedItemsToDisc.bind(this);
		this.onCloseAddToDiscDialog = this.onCloseAddToDiscDialog.bind(this);
		this.onCloseDownloadDialog = this.onCloseDownloadDialog.bind(this);
		this.onCloseDeleteDialog = this.onCloseDeleteDialog.bind(this);
		this.closeShareDialog = this.closeShareDialog.bind(this);
		this.openAddToAlbumDialog = this.openAddToAlbumDialog.bind(this);
		this.fetchMoreAlbums = this.fetchMoreAlbums.bind(this);
	}
	componentDidMount(){
		if(this.props.albums == null || this.props.albums.length == 0){
            this.props.requestAlbumList(0, this.props.amIfetching,50);
		}
	}

	favoriteAlbumItems() {
		const { favoriteAlbums, selectedAlbumItems } = this.props;
		favoriteAlbums(selectedAlbumItems);
	}

	deleteSelectedItems() {
		const { deleteSelectedItems, selectedAlbumItems } = this.props;
		this.setState({isDeleteDialogOpen: false});
		//this.deleteDialog.open();
		deleteSelectedItems(selectedAlbumItems);
		const { clearSelectedAlbumItems } = this.props;
		clearSelectedAlbumItems();
		applicationHistory.goBack();
	}

	deleteAlbumItemsDialog() {
		const {  selectedAlbumItems } = this.props;
		if(selectedAlbumItems.length >0 ){
			this.setState({isDeleteDialogOpen:true})
		}
	}
	onCloseDeleteDialog(){
		this.setState({isDeleteDialogOpen:false});
		const { clearSelectedAlbumItems } = this.props;
		clearSelectedAlbumItems();
		applicationHistory.goBack();
    }

	downloadAlbumItems() {
		this.setState({isDownloadDialogOpen:true})
	}
	onCloseDownloadDialog(){

		this.setState({isDownloadDialogOpen:false});
		const { clearSelectedAlbumItems } = this.props;
		clearSelectedAlbumItems();
		applicationHistory.goBack();
	}

	addSelectedItemsToAlbum(album, deleteOriginal) {
		if(album.id === this.props.album.id){
			alert("These assets already belong to this album")
			return;
		}
		this.setState({isAddToAlbumDialogOpen:false})
		this.props.requestAddAlbumItemsToAlbum(album.id,this.props.selectedAlbumItems, deleteOriginal)
        this.props.clearSelectedAlbumItems();
        applicationHistory.goBack();
	}
    addSelectedItemsToDisc(){
		this.setState({isAddToDiscDialogOpen: true})
	}
	onCloseAddToDiscDialog(){
		this.setState({isAddToDiscDialogOpen: false});
		const { clearSelectedAlbumItems } = this.props;
		clearSelectedAlbumItems();
		applicationHistory.goBack();
	}

	cancelSelection() {
		const { clearSelectedAlbumItems, disableAlbumItemSelectionMode } = this.props;
		clearSelectedAlbumItems();
		disableAlbumItemSelectionMode();
		applicationHistory.goBack();
	}

  	closeShareDialog() {
		this.setState({ isShareDialogOpen: false });
		const { clearSelectedAlbumItems } = this.props;
		clearSelectedAlbumItems();
		// disableAlbumItemSelectionMode();
		//applicationHistory.goBack();
	}
	openAddToAlbumDialog(){
        this.fetchMoreAlbums();
        this.setState({isAddToAlbumDialogOpen:true});
	}
	fetchMoreAlbums(){
		if(this.props.albumList.offset != this.props.albumList.count){
			if(!this.props.amIfetching){
                console.log("Requesting albums offset " + this.props.albumList.offset);
                this.props.requestAlbumList(this.props.albumList.offset,this.props.amIfetching,50);
			}
			console.log("Setting timer to fetch more albums");
			setTimeout(()=> this.fetchMoreAlbums(), 1000);
		}
	}

	render() {
		const { albumItems, selectedAlbumItems } = this.props;

		let selectedItemTypesCount = { photo: 0, video: 0 };
		selectedAlbumItems.forEach(itemId => {
			albumItems.map(item => {
				if (item.id === itemId) {
          selectedItemTypesCount[item.elementType] += 1;
        }
			});
		});

		const areItemsSelected = selectedAlbumItems.length > 0;

		return (
			<header className="select-mode header-flex-container">
				<div className="header-flex-left">
					<div className="header-item header-item-left" onClick={this.cancelSelection}>
						<div className="header-icon cancel" />
						<span className="cancel-text">Cancel</span>
					</div>
                    {selectedAlbumItems.length === 0 ? (
						<span className="album-items-selected-text header-item">Select Memories</span>
                    ) : (
						<span />
                    )}
					{selectedAlbumItems.length > 0 ? (
						<span className="album-items-selected-text header-item"> {selectedAlbumItems.length} Items Selected</span>
					) : (
						<span />
					)}
				</div>
				{areItemsSelected &&
				<div className="header-flex-right">
					{/*<div className="header-item header-item-right" onClick={this.favoriteAlbumItems}>
						<div className="header-icon favorite" />
				<div className="header-label">Favorite</div>
				</div>*/}
					<div className="header-item header-item-right" onClick={() => this.setState({ isShareDialogOpen: true })}>
						<div className="header-icon share-white" />
						<div className="header-label">Share</div>
					</div>
					{this.props.downloadEnabled &&
						<div className="header-item header-item-right" onClick={this.downloadAlbumItems}>
							<div className="header-icon download-white" />
							<div className="header-label">Download</div>
						</div>
                    }
					<div className="header-item header-item-right" onClick={()=>this.openAddToAlbumDialog()}>
						<div className="header-icon add-to-album-white" />
						<div className="header-label">Add to Album</div>
					</div>
					<div className="header-item header-item-right" onClick={this.addSelectedItemsToDisc}>
						<div className="header-icon disc-white" />
						<div className="header-label">Add to Disc</div>
					</div>
					<div className="header-item header-item-right" onClick={this.deleteAlbumItemsDialog}>
						<div className="header-icon delete-white" />
						<div className="header-label">Delete</div>
					</div>
				</div>}
                {this.state.isDeleteDialogOpen &&
                <ConfirmationDialog title={"Confirm Delete"}
                                    message={"Are you sure you want to delete this item?"}
                                    isOpen={this.state.isDeleteDialogOpen}
                                    onYesAction={this.deleteSelectedItems}
                                    onNoAction={() => this.setState({isDeleteDialogOpen: false})}
                                    onClose={this.onCloseDeleteDialog}/>
                }
				{this.state.isDownloadDialogOpen &&
				<MediaDownloadDialog
					ref={mediaDownloadDialog => (this.mediaDownloadDialog = mediaDownloadDialog)}
					isOpen={this.state.isDownloadDialogOpen}
					onClose={this.onCloseDownloadDialog}
					type="cce"
					cce={this.props.albumItems == null ?  [] : this.props.albumItems.filter(item=>item.selected)}
					/>
                }
				{this.state.isAddToDiscDialogOpen &&
				<AddToDiscDialog
					customCollectionElements={this.props.albumItems == null ?  [] : this.props.albumItems.filter(item=>item.selected)}
					onClose={this.onCloseAddToDiscDialog}
                    canCancel={true}
					isOpen={this.state.isAddToDiscDialogOpen}/>
                }
				{this.state.isShareDialogOpen &&
				<ShareDialog
					identifier={selectedAlbumItems}
          multipleAssets={true}
					onClose={this.closeShareDialog}
          photoCount={selectedItemTypesCount.photo}
          clipCount={selectedItemTypesCount.video}
				/>
				}
				{this.state.isAddToAlbumDialogOpen &&
				<AddToAlbumDialog
					onClose={()=>this.setState({isAddToAlbumDialogOpen:false})}
					onAlbumSelected={(album, deleteOriginal) => this.addSelectedItemsToAlbum(album, deleteOriginal)}
					albums={this.props.albums}
					isOpen={this.state.isAddToAlbumDialogOpen}
                    showDeleteOriginal={true}
					deleteOriginalText="Remove from original album after moving?"
					requestAlbumList={this.props.requestAlbumList}/>
				}
			</header>
		);
	}
}

AlbumItemSelectModeHeader.propTypes = {
	favoriteAlbums: PropTypes.func,
	unFavoriteAlbums: PropTypes.func,
	enableAlbumItemSelectionMode: PropTypes.func,
	disableAlbumItemSelectionMode: PropTypes.func,
	clearAlbumItems: PropTypes.func,
	clearSelectedAlbumItems: PropTypes.func,
	deleteSelectedItems: PropTypes.func,
	downloadAlbumItems: PropTypes.func,
	selectedAlbumItems: PropTypes.array,
	downloadEnabled: PropTypes.bool,
	albums: PropTypes.array,
	album: PropTypes.object,
	albumList: PropTypes.object,
    requestAlbumList: PropTypes.func,
	amIfetching: PropTypes.bool,
	requestAddAlbumItemsToAlbum: PropTypes.func
};


const mapStateToProps = state => {
	return {
		albumItems: state.albumItems.albumItems,
		selectedAlbumItems: state.albumItems.selectedItem,
        downloadEnabled: state.cart.orderType !== "RPC" && (state.settings.attributes["web.download.allow"] == null || state.settings.attributes["web.download.allow"] !== "false"),
		albumList: state.albumList,
        albums: state.albumList.albums,
        album: state.albumItems.parentAlbum,
        offset: state.albumList.offset,
        max: state.albumList.max,
        isComplete: state.albumList.isComplete,
        amIfetching: state.albumList.amIfetching,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		favoriteAlbums: ids => favoriteAlbums(dispatch, ids, true),
		unFavoriteAlbums: ids => favoriteAlbums(dispatch, ids, false),
		enableAlbumItemSelectionMode: () => dispatch(enableAlbumItemSelectionMode()),
		disableAlbumItemSelectionMode: () => dispatch(disableAlbumItemSelectionMode()),
		clearAlbumItems: () => dispatch(clearAlbumItems()),
		clearSelectedAlbumItems: () => dispatch(clearSelectedAlbumItems()),
		deleteSelectedItems: ids => deleteAlbumItems(dispatch, ids),
		downloadAlbumItems: ids => downloadAlbumItems(dispatch, ids),
        requestAddAlbumItemsToAlbum: (albumId,ids,deleteOriginal) => requestAddAlbumItemsToAlbum(dispatch,albumId,ids,deleteOriginal),
        requestAlbumList: (offset = 0, amIfetching = false, max) => {
            dispatch(albumListRequested(dispatch, offset, true, max, false, amIfetching));
        }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AlbumItemSelectModeHeader);



// WEBPACK FOOTER //
// ./src/header/components/album-item-select-mode-header.jsx